import axios from 'axios';
import CONFIG from '../config/config';

export const fetchMissions = async (subscriptionGuid) => {
  try {
    const url = `${CONFIG.API.BASE_URL}/missions/list`;
    const response = await axios.get(url, {
      headers: {
        ...CONFIG.DEFAULT_HEADERS,
        'accessToken': CONFIG.API.ACCESS_TOKEN,
        'subscriptionGuid': subscriptionGuid,
      },
    });

    if (response.status === 200) {
      //return response.data; // Mission records
      return Array.isArray(response.data.missions)
        ? response.data.missions
        : [response.data.missions];
    } else {
      console.error(`Error fetching missions: ${response.status} - ${response.data}`);
      throw new Error(`Error: ${response.status}`);
    }
  } catch (error) {
    if (error.response && error.response.status === 404) {
      console.warn('No missions found, returning empty array.');
      return [];
    }

    console.error('Error fetching missions:', error);
    throw error; // Re-throw the error for other status codes
  }
};

// Fetch a mission by GUID
export const getMissionByGuid = async (missionGuid) => {
  try {
    const url = `${CONFIG.API.BASE_URL}/missions/${missionGuid}`;
    const response = await axios.get(url, {
      headers: {
        ...CONFIG.DEFAULT_HEADERS,
        'accessToken': CONFIG.API.ACCESS_TOKEN,
      },
    });

    if (response.status === 200) {
      return response.data; // Mission details
    } else {
      console.error(`Error fetching mission by GUID: ${response.status} - ${response.data}`);
      throw new Error(`Error: ${response.status}`);
    }
  } catch (error) {
    console.error('Error fetching mission by GUID:', error);
    throw error;
  }
};

// Create a new mission
export const createMission = async (missionData) => {
  try {
    const url = `${CONFIG.API.BASE_URL}/missions/create`;
    const response = await axios.post(url, missionData, {
      headers: {
        ...CONFIG.DEFAULT_HEADERS,
        'accessToken': CONFIG.API.ACCESS_TOKEN,
      },
    });

    if (response.status === 201) {
      return response.data; // Created mission details
    } else {
      console.error(`Error creating mission: ${response.status} - ${response.data}`);
      throw new Error(`Error: ${response.status}`);
    }
  } catch (error) {
    console.error('Error creating mission:', error);
    throw error;
  }
};

// Update an existing mission
export const updateMission = async (missionGuid, updateData) => {
  try {
    const url = `${CONFIG.API.BASE_URL}/missions/update/${missionGuid}`;
    const response = await axios.patch(url, updateData, {
      headers: {
        ...CONFIG.DEFAULT_HEADERS,
        'accessToken': CONFIG.API.ACCESS_TOKEN,
      },
    });

    if (response.status === 200) {
      return response.data; // Updated mission details
    } else {
      console.error(`Error updating mission: ${response.status} - ${response.data}`);
      throw new Error(`Error: ${response.status}`);
    }
  } catch (error) {
    console.error('Error updating mission:', error);
    throw error;
  }
};